import React from "react";
import Select from "react-select";
import PendingIconImage from "../../../assets/media/icons/pending.png";
import IconStore from "../../Chatbot/components/IconStore";
import { user_actions } from "../../../Utils/Constants";
import { pages, TokenTypes } from "../../../Constants/selections";
import "./index.css";

const customStyles = {
  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: 200,
  }),
};

class TokenEarningModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      token: 0,
      showChooseIcon: false,
      icon: "",
      selectedPage: "",
      tokenType: TokenTypes[0],
    };
  }

  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  onAdd = () => {
    const { onAdd } = this.props;
    const { title, token, icon, selectedPage, user_action, tokenType } =
      this.state;
    const { value: page } = selectedPage;
    const { value: action } = user_action;
    onAdd({ icon, title, token, page, action, tokenType: tokenType.value });
    this.setState({
      icon: "",
      title: "",
      token: 0,
      selectedPage: "",
      user_action: "",
    });
  };

  onSelectImage = (icon) => {
    this.setState({ icon, showChooseIcon: false });
  };

  render() {
    const {
      title,
      token,
      icon,
      showChooseIcon,
      selectedPage,
      user_action,
      tokenType,
    } = this.state;

    return (
      <div
        className="modal fade token-earning-dialog"
        id="token_earning_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-token-earning-content">
            <div className="modal-header">
              <h5 className="modal-title">Add token earning</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 token-earning-dialog-body">
              <div className="icon-container">
                <button
                  type="button"
                  className="btn btn-warning choose-icon-btn"
                  onClick={() => {
                    this.setState({ showChooseIcon: true });
                  }}
                >
                  Choose Icon
                </button>
                <img
                  src={icon ? icon : PendingIconImage}
                  width="40"
                  alt="icon"
                />
              </div>
              {showChooseIcon && (
                <IconStore onSelectImage={this.onSelectImage} />
              )}
              <p className="token-earning-property-title">
                Token Earning Title
              </p>
              <input
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("title")}
                value={title}
              />
              <p className="token-earning-property-title">Token type</p>
              <div style={{ width: "100%" }}>
                <Select
                  options={TokenTypes}
                  onChange={(value) => this.setState({ tokenType: value })}
                  value={tokenType}
                />
              </div>
              <p className="token-earning-property-title">Number of tokens</p>
              <input
                type="text"
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("token")}
                value={token}
              />
              <div className="page-action-container">
                <div style={{ width: "45%" }}>
                  <p className="token-earning-property-title">Pages</p>
                  <div className="page-select-container">
                    <Select
                      options={Object.values(pages).map((page) => ({
                        value: page.id,
                        label: page.name,
                      }))}
                      onChange={(value) =>
                        this.setState({ selectedPage: value })
                      }
                      value={selectedPage}
                    ></Select>
                  </div>
                </div>
                <div style={{ width: "45%" }}>
                  <p className="token-earning-property-title">User Actions</p>
                  <div
                    className="page-select-container"
                    style={{ width: "100%" }}
                  >
                    <Select
                      options={user_actions}
                      onChange={(value) =>
                        this.setState({ user_action: value })
                      }
                      value={user_action}
                    ></Select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="btn-action-container">
                <button
                  type="button"
                  className="btn btn-sm btn-light add-token-warning-btn"
                  data-dismiss="modal"
                  onClick={this.onAdd}
                  disabled={
                    !this.state.icon ||
                    !token ||
                    !title ||
                    !selectedPage ||
                    !user_action
                  }
                >
                  Add
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TokenEarningModal;



// WEBPACK FOOTER //
// ./src/screens/TokenEarning/TokenEarningModal/index.js